const LAY_DANH_SACH_HO_SO_CONG_VIEC = (state, danhSachHoSoCongViec) => {
  state.danhSachHoSoCongViec = danhSachHoSoCongViec;
};

const SET_CHI_TIET_HO_SO_CONG_VIEC = (state, chiTietHoSoCongViec) => {
  state.chiTietHoSoCongViec = chiTietHoSoCongViec;
};

const SET_DOI_TUONG_DUOC_TRA_LAI = (state, doiTuongDuocTraLai) => {
  state.doiTuongDuocTraLai = doiTuongDuocTraLai;
};

const SET_TREE_DON_VI = (state, treeDonVi) => {
  state.treeDonVi = treeDonVi;
};

const SET_TREE_PHAN_XU_LY = (state, treePhanXuLy) => {
  state.treePhanXuLy = treePhanXuLy;
};

const SET_LICH_SU_THU_HOI = (state, lichSuThuHoi) => {
  state.lichSuThuHoi = lichSuThuHoi;
}

const SET_LICH_SU_TRA_LAI = (state, lichSuTraLai) => {
  state.lichSuTraLai = lichSuTraLai;
}

const SET_LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN = (state, lichSuCapNhatTinhHinhThucHien) => {
  state.lichSuCapNhatTinhHinhThucHien = lichSuCapNhatTinhHinhThucHien;
};
  
const SET_LICH_SU_PHAN_XU_LY = (state, lichSuPhanXuLy) => {
  state.lichSuPhanXuLy = lichSuPhanXuLy;
};

const SET_LUONG_XU_LY = (state, luongXuLy) => {
  state.luongXuLy = luongXuLy;
};

const SET_COUNT_LIST = (state, countList) => {
  state.countList = countList;
};

const SET_TREE_DA_PHAN_XU_LY = (state, treeDaPhanXuLy) => {
  state.treeDaPhanXuLy = treeDaPhanXuLy;
};

const SET_TREE_DA_PXL_SEARCH_DATA = (state, treeDaPXLSearchData) => {
  state.treeDaPXLSearchData = treeDaPXLSearchData;
};

export default {
  SET_TREE_DA_PXL_SEARCH_DATA,
  SET_TREE_DA_PHAN_XU_LY,
  SET_COUNT_LIST,
  SET_LUONG_XU_LY,
  LAY_DANH_SACH_HO_SO_CONG_VIEC,
  SET_CHI_TIET_HO_SO_CONG_VIEC,
  SET_DOI_TUONG_DUOC_TRA_LAI,
  SET_TREE_DON_VI,
  SET_TREE_PHAN_XU_LY,
  SET_LICH_SU_THU_HOI,
  SET_LICH_SU_PHAN_XU_LY,
  SET_LICH_SU_TRA_LAI,
  SET_LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN,
};
